import { useContext } from 'react';
import IntegrationContext from '../../contexts/IntegrationContext';

const useIntegrationContext = () => {
  const context = useContext(IntegrationContext);
  if (!context) {
    throw new Error('useIntegrationContext must be used within IntegrationContextProvider!');
  }
  return context;
};

export default useIntegrationContext;
